import { render } from "./App.vue?vue&type=template&id=97fd6eda"
const script = {}

import "./App.vue?vue&type=style&index=0&id=97fd6eda&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__